<template>
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="52" height="52" rx="12" fill="white" />
    <path
      d="M38.435 38.1294C37.7269 36.1246 36.1666 34.353 33.996 33.0895C31.8254 31.826 29.1659 31.1411 26.4299 31.1411C23.694 31.1411 21.0345 31.826 18.8639 33.0895C16.6933 34.353 15.133 36.1246 14.4249 38.1294"
      stroke="url(#paint0_linear_37_1630)"
      stroke-width="3"
      stroke-linecap="round"
    />
    <circle
      cx="26.4272"
      cy="18.7135"
      r="6.42857"
      stroke="url(#paint1_linear_37_1630)"
      stroke-width="3"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_37_1630"
        x1="14.0014"
        y1="31.1411"
        x2="32.2565"
        y2="55.041"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_37_1630"
        x1="19.9986"
        y1="12.2849"
        x2="32.8995"
        y2="25.098"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>
